<template>
  <div class="panel-data">
      <div class="status" style=" margin-bottom: 25px;">
        <div :class="[currentState]">{{ statusName[currentState] }}</div>
        <div class="btn-status mt-4">
          <div :class="['outerCircle', `c-${currentState}`]" :style="currentState==='stop'&&{animation:'none',transform: 'scale(1.6)',opacity: '0.2'}"></div>
          <div class="innerCircle">
            <img :src="statusImg[currentState]" alt="" />
          </div>
        </div>
      </div>
      <!-- 开启：暂时隐藏 -->
      <div class="pressure">
        <div :class="['cont', 'circle-bg', isDialog&&'cursor-pointer']"  @click="openDialog">
          <div :style="`color:${isRunning?'':'#d5d7d9'}`">{{ isRunning? $t("Enabled_status") :$t("page.event-management.closed") }}</div>
        </div>
        <div class="value">{{ $t("Smart O&M Model") }}</div>
      </div>
  </div>
  <!-- 智能运维模式页面 -->
  <SmartOMDetail v-if="visible&&!isPaperMaking" :visible="visible" @closeDialog="closeDialog"></SmartOMDetail>
  <smartOMDetailofPaperMaking v-if="visible&&isPaperMaking" :visible="visible" @closeDialog="closeDialog"></smartOMDetailofPaperMaking>
</template>

<script>
import SmartOMDetail from './smartOMDetail.vue';
import smartOMDetailofPaperMaking from './smartOMDetailofPaperMaking.vue';
export default {
  data() {
    return {
      statusImg: {
        normal: require("@/assets/status-normal.svg"),
        warning: require("@/assets/status-warning.svg"),
        error: require("@/assets/status-error.svg"),
        stop: require("@/assets/status-stop.svg")
      },
      stateList: ["normal", "warning", "error"],
      timer: null,
      visible:false, //弹框控制
    };
  },
  props: {
    currentState: {
      type: String,
      default: "normal"
    },
    isPanelData:{
      type:Boolean,
      default:true,
    }
  },
  watch:{},
  computed: {
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    },
    statusName() {
      return {
        normal: this.$t("Normal_status"),
        warning: this.$t("Caution_status"),
        error: this.$t("Warning_status"),
        stop:this.$t('Shutdown')
      };
    },
    /* 设备运行状态 */ 
    isRunning() { 
      let run = true
      if(this.$store.state.equipManagement.is_stmart_om_equipment){
        run = this.$store.state.equipManagement.isRunning
      }
      return run;
    },
    /* 是否允许点击展开智能运维模式页面 */
    isDialog(){
      return this.$store.state.equipManagement.is_stmart_om_equipment;
    }
  },
  mounted() {
    // if(this.isDialog){ 
    //   if(this.$store.state.equipManagement.visible){ //用于判断从dialog跳转能耗分析页面，跳转回dialog依旧展示
    //     this.visible = true
    //   }
    // }
  },
  beforeUnmount() {},
  methods: {
    randoms(min, max) {
      return parseInt(Math.random() * (max - min) + min);
    },
    /* 展开详情页面触发Function */ 
    openDialog(){
      if(this.isDialog){ //2BV6 131 0ZC00 白杨河设备展示指定图片
        this.visible = true
        this.$store.commit( "equipManagement/set_visible", this.visible);
      }
    },
    /* 关闭弹框 */ 
    closeDialog(){
      this.visible = false
      this.$store.commit( "equipManagement/set_visible", this.visible);
    }
  },
  components: { SmartOMDetail,smartOMDetailofPaperMaking }
};
</script>

<style scoped lang="scss">
.panel-data {
  position: absolute;
  top: 0px;
  left: 430px;
  z-index: 5; //由于静态模型层级 需提高点击层级
  // font-size: 14px;
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;

  > div {
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }

  .penal {
    position: absolute;
  }

  .circle-bg {
    width: 100px;
    height: 100px;
    background: url("../../../assets/circle.svg") no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    color: #00ff1e;
    .cont {
      width: 50%;
      display: flex;
      flex-flow: column;
      align-items: center;
      text-align: center;
    }
  }
  .temperature {
    justify-content: center;
    text-align: center;
    align-items: center;
    margin-bottom: 15px;
  }

  .value {
    margin-top: 10px;
    font-size: 14px;
    color: #01cee6;
    text-align: center;
  }

  .status {
    display: none;
    display: flex;
    justify-content: center;
    flex-flow: column;
    align-items: center;
    // margin-bottom: 50px;

    .btn-status {
      position: relative;
      width: 100px;
      height: 80px;
      display: flex;
      border-radius: 50%;
      justify-content: center;
      align-items: center;
      z-index: 9;
      .innerCircle {
        position: absolute;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: #071729;
      }
      .outerCircle {
        position: absolute;
        width: 70px;
        height: 70px;
        border-radius: 50%;
        animation: lockLight 1.5s ease-in-out infinite;
        &.c-normal {
          background: radial-gradient(
            circle closest-side,
            rgb(5, 255, 0) 0%,
            rgba(5, 255, 0, 0.8) 50%
          );
        }
        &.c-warning {
          background: radial-gradient(
            circle closest-side,
            rgb(248, 197, 51) 0%,
            rgba(248, 197, 51, 0.8) 50%
          );
        }
        &.c-error {
          background: radial-gradient(
            circle closest-side,
            rgb(255, 112, 111) 0%,
            rgba(255, 112, 111, 0.8) 50%
          );
        }
        &.c-stop {
          background: radial-gradient(
            circle closest-side,
            rgb(213, 215, 217) 0%,
            rgba(213, 215, 217, 0.8) 50%
          );
        }
      }
    }
    .normal {
      font-size: 16px;
      color: #05ff00;
    }
    .warning {
      font-size: 16px;
      color: #f8c533;
    }
    .error {
      font-size: 16px;
      color: #ff706f;
    }
    .stop{
      font-size: 16px;
      color: #d5d7d9;
    }
  }

  @keyframes lockLight {
    0% {
      opacity: 1;
      transform: scale(0);
    }
    10% {
      opacity: 0.8;
      transform: scale(0.2);
    }
    20% {
      opacity: 0.8;
      transform: scale(0.4);
    }
    30% {
      opacity: 0.8;
      transform: scale(0.6);
    }
    40% {
      opacity: 0.6;
      transform: scale(0.8);
    }
    50% {
      opacity: 0.6;
      transform: scale(1);
    }
    60% {
      opacity: 0.4;
      transform: scale(1.2);
    }
    70% {
      opacity: 0.4;
      transform: scale(1.4);
    }
    80% {
      opacity: 0.2;
      transform: scale(1.6);
    }
    90% {
      opacity: 0.2;
      transform: scale(1.8);
    }
    100% {
      opacity: 0;
      transform: scale(2);
    }
  }
}
</style>
